import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { endpoint } from '../../../resource/Constant';
import { parseEmail } from '../../../resource/Constant';
import { toast } from 'react-toastify';
import { Stack, TextField, Typography } from '@mui/material';
import { useTechPredAuth } from './TechPredAuthProvider';
import { motion, AnimatePresence } from 'framer-motion';
import './login.css';
import Landing from '../../../landing/Landing';

export default function TechPredLogin() {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState(['', '', '', '']);
  const otpInputs = useRef([]);
  const [resendTimer, setResendTimer] = useState(30);
  const { techPredlogin, isTechPredAuthenticated } = useTechPredAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isTechPredAuthenticated) navigate('/techpred/chat');
  }, []);
  useEffect(() => {
    let timer;
    if (otpSent && resendTimer > 0) {
      timer = setInterval(() => setResendTimer((prev) => prev - 1), 1000);
    }
    return () => clearInterval(timer);
  }, [otpSent, resendTimer]);

  const formsubmit = (e) => {
    e.preventDefault();
    if (!otpSent) {
      onLoginFormsubmit();
    } else {
      verifyOtp();
    }
  };

  const verifyOtp = () => {
    setLoading(true);
    axios
      .post(endpoint + '/api/techpred/verifyotp', {}, { params: { email, otp: otp.join('') } })
      .then((res) => {
        localStorage.setItem('techpredtoken', res?.data?.jwt);
        techPredlogin();
        navigate('/techpred/chat');
        toast.success(res?.data?.messege || 'Success');
        setLoading(false);
        setOtpSent(false);
      })
      .catch((e) => {
        toast.error(e?.response?.data?.detail || 'Something went wrong');
        setLoading(false);
      });
  };

  const onLoginFormsubmit = () => {
    setLoading(true);
    if (email === parseEmail) {
      axios.post(endpoint + '/api/techpred/parse',  {} , {params : {email}})
      .then((response) => {
        localStorage.setItem('techpredtoken', response?.data?.jwt);
        techPredlogin();
        navigate('/techpred/chat');
        toast.success(response?.data?.messege || 'Success');
        setLoading(false);
        setOtpSent(false);
      })
      .catch((error) => {
        toast.error(error?.response?.data?.detail || 'Something went wrong');
        setLoading(false);
      })
    }
    else {
      axios
      .post(endpoint + '/api/techpred/sendotp', {}, { params: { email } })
      .then((res) => {
        toast.success(res?.data?.messege || 'OTP Sent');
        setOtpSent(true);
        setResendTimer(30);
        setLoading(false);
      })
      .catch((e) => {
        toast.error(e?.response?.data?.detail || 'Something went wrong');
        setLoading(false);
      });
    }
    
  };

  return (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontFamily: "'Roboto', sans-serif",
        position: 'relative'
      }}
    >
      {/* <motion.div
        className="techpred-login-form"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      > */}
      <div className="techpred-login-form">
        <h2 style={{ color: '#0b6bcb', marginBottom: '0px', fontSize: '26px', fontWeight: 700 }}>Verify Your Email</h2>
        <p style={{ color: '#64748b', marginBottom: '20px' }}>Enter your email to get started</p>
        <form onSubmit={formsubmit}>
          <div style={{ marginBottom: '1rem' }}>
            <TextField
              type="email"
              label="you@example.com"
              placeholder="Email"
              value={email}
              disabled={otpSent}
              required
              onChange={(e) => setEmail(e.target.value)}
              fullWidth
            />
          </div>

          {otpSent && (
            <Stack direction="row" spacing={2} justifyContent="center" sx={{ mb: 2 }}>
              {otp.map((digit, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3, delay: index * 0.15 }}
                >
                  <TextField
                    inputRef={(el) => (otpInputs.current[index] = el)}
                    type="text"
                    variant="outlined"
                    value={digit}
                    disabled={!otpSent}
                    required
                    onChange={(e) => {
                      const value = e.target.value;
                      if (!isNaN(value)) {
                        const newOtp = [...otp];
                        newOtp[index] = value;
                        setOtp(newOtp);
                        if (value && index < 3) {
                          otpInputs.current[index + 1].focus();
                        }
                      }
                    }}
                    onKeyDown={(e) => {
                      if (e.key === 'Backspace' && !otp[index] && index > 0) {
                        otpInputs.current[index - 1].focus();
                      }
                    }}
                    inputProps={{
                      maxLength: 1,
                      style: { textAlign: 'center', fontSize: '18px', fontWeight: 'bold' }
                    }}
                    sx={{
                      width: '50px',
                      height: '50px',
                      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                      borderRadius: '8px'
                    }}
                  />
                </motion.div>
              ))}
            </Stack>
          )}

          <motion.button
            type="submit"
            className="btn btn-primary"
            style={{
              background: '#0b6bcb',
              border: 'none',
              color: '#fff',
              padding: '10px 20px',
              fontSize: '16px',
              width: '100%',
              borderRadius: '5px',
              cursor: 'pointer'
            }}
            disabled={loading}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            {otpSent && !loading ? 'Submit' : loading ? 'Sending OTP...' : 'Send OTP'}
          </motion.button>
        </form>

        {otpSent && (
          <Typography
            variant="body2"
            sx={{
              mt: 1,
              color: resendTimer > 0 ? 'gray' : '#1976d2',
              textAlign: 'center',
              cursor: resendTimer > 0 ? 'default' : 'pointer'
            }}
            onClick={resendTimer === 0 ? onLoginFormsubmit : null}
          >
            {resendTimer > 0 ? `Resend OTP in ${resendTimer}s` : 'Resend OTP'}
          </Typography>
        )}

        <p style={{ marginTop: '20px' }}>A one-time password (OTP) will be sent to this email.</p>
        </div>
      {/* </motion.div> */}

      {/* Loading Animation */}
      {/* <AnimatePresence>
        {loading && (
          <motion.div
            style={{
              position: 'absolute',
              width: '100vw',
              height: '100vh',
              background: 'rgba(255, 255, 255, 0.8)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              backdropFilter: 'blur(5px)'
            }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              animate={{
                scale: [1, 1.2, 1],
                rotate: [0, 360],
                borderRadius: ['20%', '50%', '20%']
              }}
              transition={{ duration: 1.5, repeat: Infinity, ease: 'easeInOut' }}
              style={{
                width: '60px',
                height: '60px',
                background: '#0b6bcb',
                borderRadius: '50%'
              }}
            />
          </motion.div>
        )}
      </AnimatePresence> */}
    </div>
  );
}
